import { render } from "./WaterQualityData.vue?vue&type=template&id=03ebf573&scoped=true"
import script from "./WaterQualityData.vue?vue&type=script&lang=js"
export * from "./WaterQualityData.vue?vue&type=script&lang=js"

import "./WaterQualityData.vue?vue&type=style&index=0&id=03ebf573&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ebf573"]])

export default __exports__